import React from 'react';

export default function SmallGridElite({ data, color }) {
    return (
        <div className="relative aspect-square rounded-[2rem] overflow-hidden group border border-white/10">
            <img src={data?.imagensDestaque?.[0] || data?.image} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80" />
            <div className="absolute bottom-4 left-4 right-4">
                <div className="text-[8px] font-black uppercase text-white/50 tracking-widest">{data?.bairro}</div>
                <h4 className="text-xs font-black text-white uppercase truncate mb-1">{data?.titulo || data?.title}</h4>
                <div className="text-sm font-black" style={{ color }}>{data?.price || data?.preco}</div>
            </div>
        </div>
    );
}